var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoicesFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 160,
    viewBox: "0 0 133 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8438 0V160H125.616C129.677 160 133 156.667 133 152.593V0H14.8438Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.23 152.593V127.111H0V152.593C0 156.667 3.32315 160 7.38479 160H125.615C121.48 160 118.23 156.667 118.23 152.593Z",
    fill: "#86C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.693 24.1484H44.6797V33.704H88.693V24.1484Z",
    fill: "#53A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.157 24.1484H91.793V33.704H118.157V24.1484Z",
    fill: "#53A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6505 24.1484H29.6133V33.704H41.6505V24.1484Z",
    fill: "#53A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.693 43.2598H44.6797V52.8153H88.693V43.2598Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.157 43.2598H91.793V52.8153H118.157V43.2598Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6505 43.2598H29.6133V52.8153H41.6505V43.2598Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.693 62.3701H44.6797V71.9257H88.693V62.3701Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.157 62.3701H91.793V71.9257H118.157V62.3701Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6505 62.3701H29.6133V71.9257H41.6505V62.3701Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.693 81.4814H44.6797V91.037H88.693V81.4814Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6505 81.4814H29.6133V91.037H41.6505V81.4814Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.157 81.4814H91.793V91.037H118.157V81.4814Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.157 100.593H91.793V110.148H118.157V100.593Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 160,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesFrame);
export default __webpack_public_path__ + "static/media/InvoicesFrame.655f9b30.svg";
export { ForwardRef as ReactComponent };